import moment from "moment"
import "moment-timezone"

// Update locale globally
moment.updateLocale("en", {
  week: {
    dow: 1,
  },
})

export default moment
